module.exports = __webpack_public_path__ + "static/media/icon-close.54e63c9c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/search/filters-mobile/icon-close.svg
// module id = 1083
// module chunks = 1